import { useEffect } from "react";
import Header from "../../common/header/header";
import Askanalyst from "../../assets/media/images/ask-first-img.png";
import AskComprehensive from "../../assets/media/images/ask-comprehensive-img.png";
import AskFinancial from "../../assets/media/images/ask-financial-img.png";
import AskRatio from "../../assets/media/images/ask-ratio-img.png";
import AskFinancialStatement from "../../assets/media/images/ask-financial-stat-img.png";
import AskRelative from "../../assets/media/images/ask-relative-img.png";
import AskSectorFundamental from "../../assets/media/images/ask-sector-fundamental-img.png";
import AskTechnical from "../../assets/media/images/ask-technical-img.png";
import AskEconomic from "../../assets/media/images/ask-economic-img.png";
import { useLocation } from "react-router-dom";

const Features = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const sections = document.querySelectorAll(".section_scroll");
    let currentIndex = 0;
    const sectionHeight = window.innerHeight;

    const handleScroll = (event) => {
      const delta = Math.sign(event.deltaY);

      if (delta > 0 && currentIndex < sections.length - 1) {
        currentIndex++;
      } else if (delta < 0 && currentIndex > 0) {
        currentIndex--;
      }

      const targetSection = sections[currentIndex];
      const sectionTop = targetSection.offsetTop;

      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });
    };

    window.addEventListener("wheel", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);

  return (
    <div className="features-screen">
      <Header />

      <div className="AlphaAnalystlight section_scroll features-main-sec">
        <div className="container">
          <div className="alpha_analysit_size">
            <span className="ask-heading">Ask Analyst</span>
            <p className="ask-paragraph">
              The ultimate research platform designed specifically for stock
              market investors.
            </p>
          </div>
          <div className="row flex-column-reverse flex-md-row feature-firt-respon">
            <div className="col-lg-6 col-sm-12 pt-lg-0 order-1 order-md-12 alphaanalystsection mt-3">
              <ul className="alphastaytext pl-4">
                <li className="mb-4 mt-4">
                  Ask Analyst empowers you to make informed decisions that drive
                  your investment success.
                </li>
                <li>
                  Start exploring now and gain a competitive edge in the world
                  of investing!
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-sm-12 order-2 order-md-1 image-preview">
              <img
                src={Askanalyst}
                className="alphaimagesizing12 img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskComprehensive} alt="" />
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>
                    Comprehensive <br /> Market Analysis
                  </h2>
                  <p className="alphastaytext">
                    Stay ahead of the curve with our comprehensive market
                    analysis.
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li>Real-time stock data</li>
                    <li className="industry_width">
                      Industry-leading research on listed companies
                    </li>
                    <li>Market dashboard</li>
                    <li>Index performance</li>
                    <li>Most active stocks, gainers, losers,</li>
                    <li>Latest research reports,</li>
                    <li>Current news</li>
                    <li>Latest grapevine</li>
                    <li>Blogs.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect1 section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>Financial Summary</h2>
                  <p className="alphastaytext">
                    Analyze the financial health of companies and compare their
                    performance to industry benchmarks
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li>Price data</li>
                    <li>Return summary</li>
                    <li>Financial data with industry comparison</li>
                    <li>Relative price performance</li>
                    <li>Key charts</li>
                  </ul>
                </div>
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskFinancial} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskRatio} alt="" />
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>Ratios and KPIs</h2>
                  <p className="alphastaytext">
                    Evaluate stocks based on full range of ratios and KPIs.{" "}
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li>Key business KPIs </li>
                    <li>Profitability ratios</li>
                    <li>Liquidity ratios</li>
                    <li>Solvency Ratios</li>
                    <li>Activity ratios</li>
                    <li>Valuation ratios</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect1 section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>Financial Statements</h2>
                  <p className="alphastaytext">
                    Dive deep into a company's financial standing and
                    performance through a user-friendly interface
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li>Income statements </li>
                    <li>Balance sheets</li>
                    <li>Cash flow statements</li>
                    <li>Annual & quarterly financial statements</li>
                    <li>Company filings</li>
                  </ul>
                </div>
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskFinancialStatement} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskRelative} alt="" />
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>
                    Relative Valuation <br />
                    Charts
                  </h2>
                  <p className="alphastaytext">
                    Make informed investment decisions with our relative
                    valuation charts. Evaluate the relative valuation of stocks
                    and identify potential investment opportunities.
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li className="mt-4">PE (Price-to-Earnings)</li>
                    <li>PBV (Price-to-Book Value)</li>
                    <li>Dividend yield</li>
                    <li>Price-to-sales ratio</li>
                    <li>
                      EV/EBITDA (Enterprise Value-to-Earnings Before Interest,
                      Taxes, Depreciation, and Amortization)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect1 section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>Sector Fundamentals</h2>
                  <p className="alphastaytext">
                    Stay up to date on key trends to assess the overall health
                    and performance of specific sectors.
                  </p>
                  <ul className="alphastaytext pl-3">
                    <li className="mt-3">Volumes</li>
                    <li>Prices</li>
                    <li>Margins</li>
                  </ul>
                </div>
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskSectorFundamental} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskTechnical} alt="" />
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>
                    Technical <br />
                    Analysis Charts
                  </h2>
                  <ul className="alphastaytext pl-3">
                    <li className="mb-3">
                      Gain insights from technical analysis with our
                      comprehensive charts.
                    </li>
                    <li className="mb-3">
                      Understand price trends, support and resistance levels,
                      and other technical indicators.
                    </li>
                    <li>
                      Incorporate technical analysis into your investment
                      strategy and improve timing of your entry and exit.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aplha_sect1 section_scroll">
        <div className="alphasectionComprehensive container">
          <div className="AlphaAnalystgrey">
            <div className="row">
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-4 pt-lg-0 m-auto">
                <div className="AlphaAnalyst">
                  <h2>Economic Analysis</h2>
                  <ul className="alphastaytext pl-3">
                    <li className="mb-4 mt-4">
                      Get a macroeconomic perspective with our analytical tables
                      and charts on key economic themes.
                    </li>
                    <li>
                      Understand the broader economic trends and their potential
                      impact on stocks and sectors.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="alphacapitalsectionchange rounded-0 bg-transparent col-lg-6 col-sm-12 pt-lg-0">
                <img src={AskEconomic} className=" img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
